import { render, staticRenderFns } from "./OtherDeliveryCard.vue?vue&type=template&id=70d0b3a6"
import script from "./OtherDeliveryCard.vue?vue&type=script&lang=js"
export * from "./OtherDeliveryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports